import api from './api';

const request = async (method, path, data) => {
  try {
    const response = await api[method](path, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || error?.message || 'Discount code request failed');
  }
};

export const fetchDiscountCodes = () => request('get', '/booking-v1/admin/promotion-codes');
export const createDiscountCode = (payload) => request('post', '/booking-v1/admin/promotion-codes', payload);
export const updateDiscountCode = (id, payload) => request('put', `/booking-v1/admin/promotion-codes/${id}`, payload);
